import { atom, useAtom, useSetAtom } from "jotai";

export const posShowSettings = false;

const posShowSettingsAtom = atom<boolean>(posShowSettings);

const usePosShowSettings = () => {
  const atom = useAtom(posShowSettingsAtom);
  return atom;
};

export const useSetPosShowSettings = () => useSetAtom(posShowSettingsAtom);

export default usePosShowSettings;
